import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboTipoIntervencionSanitariaActiva`, method: 'GET', body: null, token: token})
}
